import React from 'react';
import { Helmet } from 'react-helmet-async';
import { UserPlus } from 'lucide-react';
import BrandOrdererHub from '../../components/brand-deal/brand-orderer-hub';

// Trang riêng cho người thuê creator: tạo chiến dịch, brief, đơn nhận đề xuất và theo dõi đơn. Tách khỏi trang
// Hợp tác quảng cáo (phía creator nhận việc) và trang Quảng cáo (Cab Ads tính theo lượt bấm) theo góp ý 14/10.
const BrandOrdererPage: React.FC = () => (
  <div className="mx-auto flex w-full max-w-[1000px] flex-col gap-6 px-4 py-6 md:px-6">
    <Helmet>
      <title>Thuê creator — Cab</title>
    </Helmet>
    <div className="flex items-center gap-3">
      <span className="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-[#EAEFFA] text-[#0057FF] dark:bg-slate-700 dark:text-blue-300">
        <UserPlus size={22} />
      </span>
      <div>
        <h1 className="ui-heading text-[22px] font-bold md:text-[26px]">Thuê creator</h1>
        <p className="ui-muted text-[14px]">
          Tạo chiến dịch thuê creator đăng bài, giao brief hoặc nhận đề xuất, rồi theo dõi đơn của bạn.
        </p>
      </div>
    </div>
    <BrandOrdererHub />
  </div>
);

export default BrandOrdererPage;
